import { Container, Grid } from "@mui/material";
import ButtonNav from "../components/General/ButtonNav";
import ArcaLogo from "../assets/img/arcaLogo.png";
import { useAuth } from "../context/AuthContext";

export default function ContributorArca() {
  const { hasPermission } = useAuth();

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {hasPermission("cargar archivo persona arca") && (
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
            <ButtonNav
              title="Cargar Archivo Personas ARCA"
              image={ArcaLogo}
              //icon={<AssignmentRoundedIcon fontSize="inherit" />}
              to="/contributors/arca/charge/file"
            />
          </Grid>
        )}

        {hasPermission("ver personas arca") && (
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
            <ButtonNav
              title="Ver Personas ARCA"
              image={ArcaLogo}
              to="/contributors/arca/manager"
            />
          </Grid>
        )}

         {hasPermission("generar archivo persona arca") && (
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
            <ButtonNav
              title="Reporte Personas ARCA"
              image={ArcaLogo}
              //icon={<AssignmentRoundedIcon fontSize="inherit" />}
              to="/contributors/arca/generate/file"
            />
          </Grid>
        )}
      </Grid>
    </Container>
  );
}
